import React, { FC } from 'react';
import { useAppSelector } from '../../../../hooks/redux';
import { ReactComponent as PaperAirplaneLightIcon } from '../../../../assets/images/PaperAirplaneLight.svg';
import { ReactComponent as PaperAirplaneDarkIcon } from '../../../../assets/images/PaperAirplaneDark.svg';

export const PaperAirplaneIcon: FC = () => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (colorTheme) {
      case 'light': {
        return <PaperAirplaneLightIcon />;
      }
      case 'dark': {
        return <PaperAirplaneDarkIcon />;
      }
      default: {
        return <PaperAirplaneLightIcon />;
      }
    }
  };
  return getIcon(theme);
};
